<template>
	<div v-if="te('gallery')" class="container-fluid h-100 w-100 p-0">
		<BackButton :text="t('back_button.overview')" link="ThenVsNowOverview"></BackButton>
		<!-- <InfoButton @click="showOverlay" /> -->
		<ThenVsNowOverlay v-if="overlayVisible" @click="hideOverlay" />
		<div id="galerijCarousel" class="carousel h-100" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="false">
			<div class="carousel-inner h-100">
				<div class="carousel-item h-100" :class="{active: index === 0 }" v-for="(image, index) in tm(`then_vs_now[${$route.params.id}].images`)" :key="image">
					<div class="d-flex justify-content-center h-100">
						<div class="image-compare w-100 h-100">
							<img :src="image.now" alt="">
							<img :src="image.then" alt="">
						</div>
					</div>
				</div>
			</div>
			<div v-if="TotalImages > 1" :class="{ 'museum-overlay-items' : overlayVisible }" class="gallery-btn gallery-left-btn galerij-prev-btn" @click="previousImage">
				<img class="gallery-btn-img" src="~@/assets/img/prev.svg" />
			</div>
			<div v-if="TotalImages > 1" :class="{ 'museum-overlay-items' : overlayVisible }" class="gallery-btn gallery-right-btn galerij-next-btn" @click="nextImage">
				<img class="gallery-btn-img" src="~@/assets/img/next.svg" />
			</div>
		</div>
		<div :class="{ 'museum-overlay-items' : overlayVisible }" class="image-compare-line">
			<span class="circle left-ricle"></span>
			<div class="text left-text">
				<h1>{{ t('then_vs_now_text.then') }}</h1>
			</div>
			<div class="text right-text">
				<h1>{{ t('then_vs_now_text.now') }}</h1>
			</div>
			<span class="circle right-ricle"></span>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Carousel, Modal } from "bootstrap";
import ImageCompare from "@/assets/js/image-compare-viewer.js";
import BackButton from "@/components/buttons/BackButton.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";
import ThenVsNowOverlay from "@/components/then-vs-now/Overlay.vue";

export default {
	name: "ThenVsNow",
	components: {
		BackButton,
		InfoButton,
		ThenVsNowOverlay,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
	data() {
		return {
			Carousel: null,
			TotalImages: 1,
			CurrentImage: 1,
			ImageComparers: [],
			Options: {
				controlColor: "#9F3232",
				controlShadow: false,
				addCircle: true,
				addArrows: false,
				addCircleBlur: false, // default
				fluidMode: true,
				leftRightOffset: 108,
			},
		};
	},
	mounted() {
		this.Carousel = new Carousel(document.getElementById("galerijCarousel"));

		const { tm } = useI18n();

		this.TotalImages = tm(`then_vs_now[${this.$route.params.id}].images`).length;

		const viewers = document.querySelectorAll(".image-compare");

		viewers.forEach((element) => {
			let view = new ImageCompare(element, this.Options).mount();

			this.ImageComparers.push(view);
		});
	},
	updated() {
		this.Carousel = new Carousel(document.getElementById("galerijCarousel"));

		const { tm } = useI18n();

		this.TotalImages = tm(`then_vs_now[${this.$route.params.id}].images`).length;

		this.ImageComparers = [];

		const viewers = document.querySelectorAll(".image-compare");

		viewers.forEach((element) => {
			let view = new ImageCompare(element, this.Options).mount();

			this.ImageComparers.push(view);
		});
	},
	methods: {
		nextImage(event) {
			if (this.Carousel) {
				this.CurrentImage++;

				if (this.CurrentImage > this.TotalImages) {
					this.CurrentImage = 1;
				}

				this.Carousel.next();
				event.stopPropagation();
			}
		},
		previousImage(event) {
			if (this.Carousel) {
				this.CurrentImage--;

				if (this.CurrentImage < 1) {
					this.CurrentImage = this.TotalImages;
				}

				this.Carousel.prev();
				event.stopPropagation();
			}
		},
	},
};
</script>

<style scoped>
.gallery-grid {
	margin-top: 240px;
	display: grid;
	grid-template-columns: auto auto auto;
	column-gap: 80px;
	row-gap: 50px;
}

.gallery-item {
	height: 274px;
	width: 424px;
}

.gallery-btn {
	z-index: 20;
	position: absolute;
	background-color: #1F1F1F;
	width: 99px;
	height: 99px;
}

.gallery-left-btn {
	left: 0;
	top: 45%;
}

.gallery-right-btn {
	right: 0;
	top: 45%;
}

.gallery-close-btn {
	right: 0;
	top: 0;
}

.gallery-btn-img {
	position: absolute;
	height: 67px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}

.image-number {
	position: absolute;
	left: 0;
	right: 0;
	text-align: center;
	bottom: 10px;
	color: #fff;
}

.image-compare-line {
	position: absolute;
	z-index: 4;
	background: #4a4a4a;
	height: 2px;
	left: 90px;
	right: 90px;
	bottom: 204px;
}

.image-compare-line > .circle {
	position: absolute;
	width: 36px;
	height: 36px;
	top: -18px;
	background-color: white;
	border-radius: 100%;
	border: var(--global-primary-theme-clr) 2px solid;
}

.image-compare-line > .circle.left-ricle {
	left: 0;
}

.image-compare-line > .circle.right-ricle {
	right: 0;
}

.image-compare-line .text {
	z-index: 50;
	position: absolute;
	top: 40px;
	color: white;
}

.image-compare-line .left-text {
	left: 0;
}

.image-compare-line .right-text {
	right: 0;
}
</style>